module.exports = __webpack_public_path__ + "75e0d5b53deac5313716f0fce65e36ba.svg";